export const PIROEntityTypes = {
  MasterAlloys: 16,
  JobItem: 107,
  JOB_IMAGES: 1000,
  PRICE_QUOTE: 22,
  SALES_ORDER: 127,

}
